var $bd2b9d1b2cbc6238$exports = {};
$bd2b9d1b2cbc6238$exports = {
    "breadcrumbs": `Br\xf8dkrummer`
};


export {$bd2b9d1b2cbc6238$exports as default};
//# sourceMappingURL=da-DK.mjs.map
